import React, { useState } from "react";
import { SafeAreaView, Platform, StatusBar } from "react-native";
import { Box } from "digiwash-components";

import MapView from "./MapView-component";
import SaveMapButton from "./SaveMapButton-component";
import MapContent from "./MapContent-component";
import MapAddressForm from "./MapAddressForm-component";
import Header from "../../components/AppHeader";
import useBack from "../../hooks/useBack";

const defaultLocation = {
  latitudeDelta: 0.2643884660682616,
  longitudeDelta: 0.1833229511976242,
  latitude: 35.69985442714949,
  longitude: 51.33782486434733,
};

let androidPadding = Platform.OS === "android" ? StatusBar.currentHeight : 0;
const safeAreStyles = {
  flex: 1,
};

let webStyles =
  Platform.OS === "web"
    ? {
        width: "100vw",
        height: "100vh",
      }
    : {};

interface PropsType {
  onSave: any;
}
function MapAddress(props: PropsType) {
  let back = useBack();
  let [location, setLocation] = useState<{
    latitude: number;
    longitude: number;
    latitudeDelta: number;
    longitudeDelta: number;
  }>(undefined);
  let [isMapReady, setMapReady] = useState(false);
  let [step, setStep] = useState(1);
  let [isSavingAddress, setSavingAddress] = useState(false);
  let isSaveMapDisabled =
    !location ||
    (location.latitude === defaultLocation.latitude &&
      location.longitude === defaultLocation.longitude);

  return (
    <Box style={{ flex: 1, ...webStyles }}>
      <Header title="افزودن آدرس" onBack={back} />

      <SafeAreaView
        style={{
          ...safeAreStyles,
          ...{
            position: "relative",
            height: "100%",
          },
        }}
        pointerEvents="box-none"
      >
        {isMapReady && <MapContent />}
        <MapView
          defaultRegion={defaultLocation}
          region={location}
          onChangeRegion={(region) => {
            setLocation(region);
          }}
          onReady={() => {
            setMapReady(true);
          }}
        />
      </SafeAreaView>

      {step === 2 && (
        <MapAddressForm
          isVisible={true}
          selectedLocation={location}
          disabled={isSavingAddress}
          onBack={() => setStep(1)}
          onSave={(title, address) => {
            setSavingAddress(true);
            props.onSave({
              onEnd: () => {
                setSavingAddress(false);
              },
              region: location,
              address,
              title,
            });
          }}
        />
      )}
      {step === 1 && (
        <SaveMapButton disabled={isSaveMapDisabled} onSave={() => setStep(2)} />
      )}
    </Box>
  );
}

export default MapAddress;
